import React from 'react';
import PropTypes from 'prop-types';
import ModalNotification from 'components/modalNotification/ModalNotification';
import ActionConfirmation from './ActionConfirmation';

const Confirmation = ({ confirmation, setConfirmation }) => {
  /* modal confirmation.variants
    success
    error
    info
    warning
    infoStatic
  */

  return (
    <div style={{ position: 'relative', zIndex: '1206' }}>
      <ModalNotification
        // TODO: allow for different icons
        variant={confirmation.variant || 'success'}
        onHide={() => setConfirmation(() => null)}
        suppressIcon={false}
        data-qa="action-modal"
        show={confirmation}
      >
        <ActionConfirmation confirmation={confirmation} setConfirmation={setConfirmation} />
      </ModalNotification>
    </div>
  );
};

Confirmation.propTypes = {
  confirmation: PropTypes.shape({
    variant: PropTypes.string
  }).isRequired,
  setConfirmation: PropTypes.func.isRequired
};

const useConfirmation = () => {
  const [confirmation, setConfirmation] = React.useState(null);
  return [
    confirmation
      ? () => <Confirmation confirmation={confirmation} setConfirmation={setConfirmation} />
      : () => null,
    setConfirmation
  ];
};

export default useConfirmation;
